import request from '@/utils/request'

const _Prefix = "/area"

// 查询房源信息列表
export function areaList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}